// Module
var code = `<table class="table table--wide" ng-form="\$ctrl.customVariableForm" ng-if="\$ctrl.print">
  <thead>
  <th>No</th>
  <th>Variable code</th>
  <th>Type</th>
  <th>Required</th>
  <th>Format</th>
  <th>Text</th>
  <th>Action</th>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$ctrl.getCustomVariables()">
    <td class="print-details__control-number">
      {{\$index+1}}.
    </td>
    <td>
      {{item.field}}
    </td>
    <td>
      <select name="printVariableType"
              ng-model="item.customVariableConfig.CUSTOM_VARIABLE_TYPE"
              ng-change="\$ctrl.clearItem(item)"
              ng-options="printVariableType | prettyEnum for printVariableType in \$ctrl.printVariableTypes"
              required>
      </select>
    </td>
    <td>
      <select ng-model="item.customVariableConfig.REQUIRED"
              ng-required="true"
              boolean-options>
      </select>
    </td>
    <td>
      <select ng-if="['USER', 'CUSTOMER'].includes(item.customVariableConfig.CUSTOM_VARIABLE_TYPE)"
              name="nameFormatType"
              ng-model="item.customVariableConfig.EFFECTIVE_NAME_FORMAT"
              ng-options="nameFormatType | prettyEnum for nameFormatType in \$ctrl.nameFormatTypes"
              ng-required="true">
      </select>
    </td>
    <td>
      <input name="text"
             ng-model="item.text"
             ng-change="\$ctrl.onChange()"
             ng-required="true">
    </td>
    <td>
      <button type="button"
              class="btn btn-danger"
              ng-click="\$ctrl.removeLine(item) && \$ctrl.onChange()">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
  <tfoot>
    <td/>
    <td>
      <input type="text"
             maxlength="256"
             ng-model="\$ctrl.field"
             ng-class="{'nx-invalid': \$ctrl.hasDuplicateNames()}"
             pattern="[a-z]{1}\\w*">
    </td>
    <td>
      <select name="printVariableType"
              ng-model="\$ctrl.printVariableType"
              ng-change="\$ctrl.clear()"
              ng-options="printVariableType | prettyEnum for printVariableType in \$ctrl.printVariableTypes"
              required>
      </select>
    </td>
    <td>
      <select ng-model="\$ctrl.required"
              ng-required="true"
              boolean-options>
      </select>
    </td>
    <td>
      <select ng-if="['USER', 'CUSTOMER'].includes(\$ctrl.printVariableType)"
              name="nameFormatType"
              ng-model="\$ctrl.nameFormat"
              ng-options="nameFormatType | prettyEnum for nameFormatType in \$ctrl.nameFormatTypes">
      </select>
    </td>
    <td>
      <input name="text" ng-model="\$ctrl.text">
    </td>
    <td>
      <button type="button"
              class="btn btn-success"
              ng-disabled="!\$ctrl.isFieldNameValid()"
              ng-click="\$ctrl.addCustomVariable() && \$ctrl.onChange()">
        Add
      </button>
    </td>
  </tr>
  </tfoot>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-custom-variable-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;